import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CasesService } from 'src/app/core/services/cases.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { ResumeService } from '../../dashboard/services/resume.service';

@Component({
  selector: 'app-main-reports-resume',
  templateUrl: './main-reports-resume.component.html',
  styleUrls: ['./main-reports-resume.component.scss'],
})
export class MainReportsResumeComponent implements OnInit {
  constructor(
    private readonly fb: FormBuilder,
    private readonly unitsService: UnitsService,
    private readonly userService: UserService,
    private resumeService: ResumeService
  ) {}

  units = [];
  ngOnInit() {
    this.getUsers();
    this.unitsService.getAllData(this.userService.currentUser).subscribe({
      next: (data) => {
        this.units = data;
      },
    });
  }
  form: FormGroup = this.fb.group({
    user: [''],
    unit: [''],
    case_type: [''],
    start: [''],
    end: [''],
  });
  get getUnits() {
    return this.units.map((x) => x.unit);
  }
  unitsSelected = [];
  get caseTypes() {
    let caseTypes: any[] = [];
    if (this.form.value.unit) {
      for (const key of this.form.value.unit) {
        let data = this.units.find((x) => x.unit._id == key);
        if (data) caseTypes = [...caseTypes, ...data.cases];
      }
    }
    // let data = this.units.find((x) => x.unit._id == this.form.value.unit);
    // if (data) caseTypes = [...caseTypes, ...data.cases];
    return caseTypes;
  }

  // get units() {
  //   return this.data.map((x) => x.unit);
  // }
  // get cases() {
  //   let cases: ICaseType[] = [];
  //   for (const key of this.unitsSelected) {
  //     let data = this.data.find((x) => x.unit._id == key);
  //     cases = [...cases, ...data.cases];
  //   }
  //   return cases;
  // }

  usersSelected;
  getUsers() {
    this.userService.getAll().subscribe((res) => {
      this.usersSelected = res;
    });
  }
  async findUser() {
    this.form.value.user = undefined;
    // this.unitsService.getTypeCases(this.form.unit).subscribe({
    //   next: (caseTypes) => {
    //     this.caseTypes = caseTypes;
    //     if (this.caseType) {
    //       this.findUser();
    //     }
    //   },
    // });
    let caseType: any = [];
    for (let case_type of this.form.value.case_type) {
      caseType = [
        ...caseType,
        ...this.caseTypes.filter((item) => item._id == case_type),
      ];
    }

    const roles = [];
    for (let caseTyp of caseType) {
      roles.push(caseTyp.role);
    }

    const users: any[] = [];

    for (const role of roles) {
      const usersByRole = await this.userService
        .getUsersByRole(role)
        .toPromise();
      users.push(...usersByRole);
    }

    // Usar un objeto temporal para realizar la eliminación de duplicados
    let uniqueUsers = {};
    users.forEach((user) => {
      uniqueUsers[user._id] = user;
    });

    // Convertir el objeto de usuarios únicos nuevamente a un array
    let usersWithoutDuplicates = Object.values(uniqueUsers);
    this.usersSelected = usersWithoutDuplicates;
  }

  search() {
    const data = { ...this.form.value };
    if (data.unit) data.unit = data.unit.join(';');
    if (data.user) data.user = data.user.join(';');
    if (data.case_type) data.case_type = data.case_type.join(';');
    data.current = this.userService.currentUser._id;
    this.resumeService.filterResumeReport.next(data);
  }
  cleanFilter() {
    this.getUsers();
    this.form.reset();
  }
}
